module.exports = __webpack_public_path__ + "b95181faf536a1985d9686e6f81ce14a.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/amplification/paid-fb.png
// module id = 3285
// module chunks = 69